import { Check, Copy } from 'lucide-react';
import { useState } from 'react';
import { cn } from '../../utils/cn';
import { Button } from '../button/button';

type CopyIconProps = {
  textToCopy: string;
  iconSize?: 'sm' | 'md' | 'lg';
};

/**
 * @param textToCopy - The text to copy to the clipboard.
 * @param iconSize - The size of the icon in pixels. 'sm' is 12x12px, 'md' is 16x16px, 'lg' is 20x20px. Defaults to 'md'.
 */
export const CopyIcon = ({ textToCopy, iconSize: size = 'md' }: CopyIconProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const handleOnClick = async () => {
    await navigator.clipboard.writeText(textToCopy);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  return (
    <Button variant="ghost" size="icon" onClick={handleOnClick}>
      {isCopied ? (
        <Check
          className={cn('text-seapoint-green', {
            'h-3 w-3': size === 'sm',
            'h-4 w-4': size === 'md',
            'h-5 w-5': size === 'lg',
          })}
        />
      ) : (
        <Copy
          className={cn('text-seapoint-gray-text', {
            'h-3 w-3': size === 'sm',
            'h-4 w-4': size === 'md',
            'h-5 w-5': size === 'lg',
          })}
        />
      )}
    </Button>
  );
};
